import AttendanceService from "./AttendanceService";

const getAll = async (pDate) => {
  const res = await AttendanceService.GetEmpDesignationCount(pDate);

  // Handle all common response shapes from the backend
  const raw = res?.data?.Data ?? res?.data?.ResultSet ?? res?.data ?? [];

  const list = Array.isArray(raw) ? raw : [];

  return list.map((item) => ({
    Designation: item.Designation ?? item.designation ?? "",
    Strength:    item.Strength    ?? item.strength    ?? 0,
    Attendance:  item.Attendance  ?? item.attendance  ?? 0,
    Percentage:  item.Percentage  ?? item.percentage  ?? 0,
  }));
};

export default { getAll };